import {edgeBrushPath} from "./linearShape";

class Brush {
    constructor() {
        this.originX = 0
    }

    init(container, containerBox) {
        this.container = container;
        this.brushYPosition = 0;
        this.containerHeight = containerBox.height;
        this.brushSize = {
            x: 0,
            width: 1
        }
    }

    create(enableMarker = false) {
        this.enableMarker = enableMarker;
        this.brush = this.container
            .append("rect")
            .attr("class", "brush")
            .attr("x", this.brushSize.x)
            .attr("y", this.brushYPosition)
            .attr("width", this.brushSize.width)
            .attr("height", this.containerHeight)
            .style("cursor", "grab")
            .style("fill", "orange")
            .style("opacity", .2)

        this.brushFirstEdge = this.container
            .append("path")
            .attr("class", "firstEdge")
            .style("cursor", "grabbing")
            .style("stroke", "#000")
            .style("stroke-width", 1)
            .style("opacity", 1);

        this.brushSecondEdge = this.container
            .append("path")
            .attr("class", "secondEdge")
            .style("cursor", "grabbing")
            .style("stroke", "#000")
            .style("stroke-width", 1)
            .style("opacity", 1);

        return [this.brush, this.brushFirstEdge, this.brushSecondEdge];
    }

    onCreateBrush(dragEvent, scroll = 0) {
        if (dragEvent.type === "start") {
            this.startX = dragEvent.x;
            this.brushSize.x = this.startX;
            this.brushSize.width = .1;

        } else if (dragEvent.type === "drag") {

            if (dragEvent.x > this.startX) {
                this.brushSize.x = this.startX + scroll;
                this.brushSize.width = dragEvent.x - this.brushSize.x;
            } else {
                this.brushSize.x = dragEvent.x;
                this.brushSize.width = this.startX - dragEvent.x;
            }
            this.startX += scroll;
        }
        this.brushSize.width < 0 ? .1 : this.brushSize.width;
        this.draw();
    }

    draw() {
        this.brush
            .attr("x", this.brushSize.x)
            .attr("y", this.brushYPosition)
            .attr("width", this.brushSize.width)
            .attr("height", this.containerHeight)


        this.brushFirstEdge
            .attr("d", edgeBrushPath(this.brushSize.x, this.brushYPosition, this.containerHeight, this.enableMarker))

        this.brushSecondEdge
            .attr("d", edgeBrushPath(this.brushSize.x + this.brushSize.width, this.brushYPosition, this.containerHeight, this.enableMarker))
    }

    onDrag(dragEvent) {
        if (dragEvent.type === "start") {
            this.currentX = dragEvent.x
            this.offsetDragX = dragEvent.x - this.brushSize.x
        } else if (dragEvent.type === "drag") {
            this.brushSize.x = dragEvent.x - this.offsetDragX
        }
        this.draw();
    }

    onDragEdges(dragEvent, selector, scroll = 0) {
        if (dragEvent.type === "start") {
            this.currentX1 = this.brushSize.x;
            this.currentX2 = this.brushSize.x + this.brushSize.width;
        } else if (dragEvent.type === "drag") {
            if (selector.attr('class') === "secondEdge") {
                if (dragEvent.x < this.currentX1) {
                    this.currentX1 += scroll;
                    this.brushSize.x = dragEvent.x + scroll;
                    this.brushSize.width = this.currentX1 - dragEvent.x;
                } else {
                    this.brushSize.x += scroll;
                    this.brushSize.width = dragEvent.x - this.brushSize.x
                }
            } else {
                if (dragEvent.x > this.currentX2) {

                    this.currentX1 = this.currentX2;
                    this.brushSize.width = dragEvent.x - this.currentX1;

                    if (scroll) {
                        this.brushSize.x += scroll;
                        this.currentX2 += scroll;
                    }
                } else {
                    this.currentX2 += scroll
                    this.brushSize.x = dragEvent.x
                    this.brushSize.width = this.currentX2 - dragEvent.x

                }
            }
        }

        this.brushSize.width < 0 ? 1 : this.brushSize.width;
        this.draw();
    }

    getParameters() {
        return this.brushSize;
    }

    getCurrentX() {
        return this.currentX;
    }

    getOffsetDragX(event) {
        return Math.abs(this.currentX - event.x);
    }

    setParameters(newParameters) {
        this.brushSize = newParameters
        this.draw()
    }

    setUp(newBrushY, newBrushHeight) {
        this.brushYPosition = newBrushY;
        this.containerHeight = newBrushHeight;

        this.draw();
    }

    hide() {
        this.brush.style("opacity", "0")
        this.brushFirstEdge.style("opacity", "0")
        this.brushSecondEdge.style("opacity", "0")
    }

    show() {
        this.brush.style("opacity", ".3")
        this.brushFirstEdge.style("opacity", "1")
        this.brushSecondEdge.style("opacity", "1")
    }

    selected() {
        this.brush.style("opacity", ".2")
    }

    deselected() {
        this.brush.style("opacity", ".2")
    }

    get() {
        return this.brush;
    }
}

export default Brush;